import { lazy } from "react";

const KEY = "casaneo_chunk_reload_at";
const CHUNK_RE = /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed/i;

export const isChunkError = (error) => CHUNK_RE.test(`${error?.name || ""} ${error?.message || error || ""}`);

// Reloads the page once when an old build's chunk is gone; the 15s guard prevents reload loops.
export const reloadOnceForChunkError = (error) => {
  if (!isChunkError(error)) return false;
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 15000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
};

export const lazyWithReload = (factory) =>
  lazy(() =>
    factory().catch((error) => {
      if (reloadOnceForChunkError(error)) return new Promise(() => {});
      throw error;
    })
  );
